import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import DevisList from "@/pages/DevisList";
import DevisEditor from "@/pages/DevisEditor";
import FacturesList from "@/pages/FacturesList";
import FactureDetail from "@/pages/FactureDetail";
import FactureEditor from "@/pages/FactureEditor";
import LibraryPage from "@/pages/Library";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/clients" element={<Protected><Clients /></Protected>} />
            <Route path="/devis" element={<Protected><DevisList /></Protected>} />
            <Route path="/devis/new" element={<Protected><DevisEditor /></Protected>} />
            <Route path="/devis/:id" element={<Protected><DevisEditor /></Protected>} />
            <Route path="/factures" element={<Protected><FacturesList /></Protected>} />
            <Route path="/factures/:id" element={<Protected><FactureDetail /></Protected>} />
            <Route path="/factures/:id/edit" element={<Protected><FactureEditor /></Protected>} />
            <Route path="/bibliotheque" element={<Protected><LibraryPage /></Protected>} />
            <Route path="/parametres" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
